import React, { useEffect, useState } from "react";
import { CreationCard } from "@/components/CreationCard";
import { TOOLS, IMAGE_TOOLS, VIDEO_TOOLS } from "@/config/tools";
import { SERVICE_BADGES } from "@/config/badges";
import client from "@/lib/apiClient";

export default function CreatePage() {
  const [enabled, setEnabled] = useState(null);
  const [tab, setTab] = useState("image"); // "image" | "video"

  useEffect(() => {
    client
      .get("/tools")
      .then(({ data }) => setEnabled(new Set(data.map((t) => t.service))))
      .catch(() => setEnabled(new Set(Object.keys(TOOLS))));
  }, []);

  const isOn = (s) => !enabled || enabled.has(s);
  const activeTools = tab === "image" ? IMAGE_TOOLS : VIDEO_TOOLS;
  const subtitle = tab === "image"
    ? "Static creatives — ads, thumbnails, posts and utilities."
    : "Cinematic short videos powered by Grok Imagine.";

  const tabBtn = (key, label, testId) => (
    <button
      key={key}
      type="button"
      data-testid={testId}
      onClick={() => setTab(key)}
      className={`h-10 rounded-full border px-5 text-sm font-semibold transition-colors ${
        tab === key
          ? "border-primary bg-primary text-primary-foreground"
          : "border-border bg-background hover:border-primary/40"
      }`}
    >
      {label}
    </button>
  );

  return (
    <div className="mx-auto max-w-7xl px-5 py-14 sm:px-8">
      <div className="mb-4">
        <h1 className="text-3xl font-bold tracking-tight sm:text-4xl">What would you like to create?</h1>
        <p className="mt-3 text-muted-foreground">Pick a creation type — configure, generate, download.</p>
      </div>

      <div className="mt-8 flex flex-wrap items-center gap-3" role="tablist" aria-label="Creation type">
        {tabBtn("image", "Image Generation", "tab-image-generation")}
        {tabBtn("video", "Video Generation", "tab-video-generation")}
      </div>

      <section
        className="mt-8"
        data-testid={tab === "image" ? "section-image-generation" : "section-video-generation"}
      >
        <p className="mb-6 text-sm text-muted-foreground">{subtitle}</p>
        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {activeTools.filter(isOn).map((s, i) => (
            <CreationCard
              key={s}
              service={s}
              name={TOOLS[s].title}
              description={TOOLS[s].subtitle}
              icon={TOOLS[s].icon}
              badge={SERVICE_BADGES[s]}
              index={i}
            />
          ))}
        </div>
      </section>
    </div>
  );
}
